import { createFileRoute } from "@tanstack/react-router";
import { BuildingIcon } from "lucide-react";
import { CompaniesTable } from "@/components/admin/companies-table";
import { requireAdminSection } from "@/lib/admin-guard";

export const Route = createFileRoute("/_admin/companies/")({
  beforeLoad: ({ context }) => requireAdminSection(context.auth.capabilities, "companies"),
  component: AdminCompaniesPage,
});

function AdminCompaniesPage() {
  return (
    <div className="flex flex-1 flex-col gap-8 p-6">
      <header className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-xs font-medium uppercase tracking-wider text-muted-foreground">
          <BuildingIcon className="size-3.5" />
          Operate
        </div>
        <div className="flex flex-col gap-1">
          <h1 className="font-heading text-3xl font-semibold tracking-tight">Companies</h1>
          <p className="max-w-2xl text-sm text-muted-foreground">
            Every company on the platform, its owner, and how many members it has. Open a company to
            view its employees or reassign its owner.
          </p>
        </div>
      </header>

      <CompaniesTable />
    </div>
  );
}
